export default {
    route: {
      dashboard: 'principal sheet',
      introduction: 'Introduction',
      documentation: 'Documentation',
      guide: ' management',
      guide1:'System user',
      guide2:'Role ',
      guide3:'Regional ',
      errorPages: 'Error Pages',
      page401: '401',
      page404: '404',
      errorLog: 'Error Log',
      permission: 'Permission',
      pagePermission: 'Page Permission',
      directivePermission: 'Directive Permission',
      service :'Service-ment',
      service1 :'personnel',
      service2 :'customer',
      service3 :'record',
      service4 :'project',
      service5 :'details',
      recycle:'recycle',
      cycle:'回收站',
      increase:'increase',
      delete:'delete',
      reset:'reset',
      edit:'edit',
      query:'query',
      personal:'personal',
      export:'export',
      notice:'notice',
      customer:'customer',
      record:'record',
      reduction:'reduction',
    },
    login: {
        title: 'Login Form',
        logIn: 'Log in',
        username: 'Username',
        password: 'Password',
        title1:'Door-to-door service background management system',
        password1:'remember the password',
        name:'Please enter the correct user name',
        pass:'The password can not be less than 6 digits',
    },
    navbar: {
      logOut: 'Log Out',
      logOut1: 'Personal Center',
      dashboard: 'Dashboard',
      github: 'Github',
      theme: 'Theme',
      size: 'Global Size'
    },
    guide: {
      description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
      button: 'Show Guide'
    },
    tagsView: {
      refresh: 'Refresh',
      close: 'Close',
      closeOthers: 'Close Others',
      closeAll: 'Close All'
    },
    permission: {
      roles: 'Your roles',
      switchRoles: 'Switch roles',
      tips: 'In some cases it is not suitable to use v-permission, such as element Tab component or el-table-column and other asynchronous rendering dom cases which can only be achieved by manually setting the v-if.'
    },

}